import { render, staticRenderFns } from "./tedian.vue?vue&type=template&id=8cc4ec34&scoped=true&"
import script from "./tedian.vue?vue&type=script&lang=js&"
export * from "./tedian.vue?vue&type=script&lang=js&"
import style0 from "./tedian.vue?vue&type=style&index=0&id=8cc4ec34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc4ec34",
  null
  
)

export default component.exports